'use client'

import { concludePaymentAction } from './concludePaymentAction'
import type { Locale } from '@/i18n/types'

export async function finalizePaymentAction(donationToken: string, locale: Locale) {
  const result = await concludePaymentAction({ paymentToken: donationToken }, { locale, returnToOnAuthErrorUrl: '' })
  return result
}
